<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="WrkCtrTable" :fields="fields" :title="table_title.title1" :show_query_container="true"
        :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false" :show_toolbar="true" :show_filter="true"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query"
        @state_change="state_change" :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke"
        @on_cell_button_click="on_cell_button_click">
        <template #toolbar>
          <el-button type="info" plain @click="createData()" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
          </el-button>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 资源表 -->
    <BaseModal ref="ElectricityPricesTable" :title="spoilage_modal_title" @saveData="SaveData" :width="'30%'">
      <template #modal_content>
        <el-form ref="dataForm" label-width="100px" class="demo-dataForm" style="height: 200px">
          <span v-for="(item,index) in SpoilagePricesModel" :key="index">
            <el-col :span="18">
              <!-- <el-form-item :label="item.label" v-if="item.key=='dataAreaId'">
                <el-select size="small" v-model="item.value" filterable clearable placeholder="请选择销售公司" class="w-100">
                  <el-option v-for="(t,k) in getCompanyOptions()" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item :label="item.label" v-if="item.key == 'Ratio'">
                <el-input type="number" v-model="item.value"></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key != 'id'">
                <el-input type="text" v-model="item.value"></el-input>
              </el-form-item>

            </el-col>
          </span>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer";
import TableMain from "../components/table/TableMain";
import BaseModal from "../components/modals/baseModal";
import TestQueryPanel from "../components/base/TestQueryPanel";
import * as SpoilageTypeRatioController from "../../controllers/base/SpoilageTypeRatioController";

export default {
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_product_parts",
      },
      fields: SpoilageTypeRatioController.fields.default,
      SpoilagePricesModel: [],
      spoilage_modal_title: "",
      isBusy: false,
    };
  },
  created() {
    this.SpoilagePricesModel = _.map(this.fields, (t) => {
      let m = {
        key: t.key,
        label: t.label,
        value: "",
        dataType: "input",
        seq: 0
      }
      return m
    })
    this.SpoilagePricesModel = _.orderBy(this.SpoilagePricesModel, ["seq"], ["asc"])
  },
  mounted() {
  },
  methods: {
    getCompanyOptions() {
      return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (v) => {
        return {
          value: v.DataArea,
          label:
            v.DataArea + ":" + (v.CompanyName == null ? "" : v.CompanyName),
        };
      });
    },
    //#region 查询
    async on_query(set_data) {
      this.isBusy = true;
      set_data([]);
      let p = { is_deleted: { "=": 0 } }
      let _result = await SpoilageTypeRatioController.methods.getData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]));
      }
      this.isBusy = false;
    },
    //#endregion

    //#region 保存
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      let ask = await this.msgModal(this.$t("notify.is_deleted"));
      if (!ask) {
        cb(false);
        return;
      }
      let p = {};
      p.delete = data.selected_items;
      let rt = await SpoilageTypeRatioController.methods.saveData(p);
      if (rt) {
        this.$refs.WrkCtrTable.RemoveItems(rt[0])
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        };
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data);
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data);
      }
    },
    //#endregion

    ///新增、编辑
    createData() {
      this.spoilage_modal_title = "新建加放类型"
      _.each(this.SpoilagePricesModel, (t) => {
        switch (t.key) {
          default: t.value = ""
        }
      });
      this.$refs.ElectricityPricesTable.show()
    },
    on_cell_button_click(data) {
      this.spoilage_modal_title = "编辑加放类型"
      for (var k in data.item) {
        let m = _.find(this.SpoilagePricesModel, { key: k });
        if (m) {
          m.value = data.item[k]
        }
      }
      this.$refs.ElectricityPricesTable.show()
    },
    async SaveData(cb) {
      //数据验证
      let msg = "", am = {}, valid_null_list = ["SpoilageType", "Ratio"];
      _.each(this.SpoilagePricesModel, (t) => {
        am[t.key] = t.value;
        if (msg == "" && valid_null_list.includes(t.key) && t.value == "") {
          msg = t.label + "不能为空！"
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }

      let p = {};
      am.dataAreaId = "017";
      if (am.id == "") {
        delete am.id;
        p.add = am;
      }
      else {
        p.edit = am;
      }
      let rt = await SpoilageTypeRatioController.methods.saveData(p);
      if (rt) {
        for (var k in p) {
          if (k == "add") {
            this.$refs.WrkCtrTable.InsertItems(rt[0])
          }
          else if (k == "edit") {
            let tm = _.find(this.$refs.WrkCtrTable.my_data, { id: rt[0].id });
            if (tm) {
              Object.assign(tm, rt[0])
            }
          }
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true, true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },

  },
};
</script>

